<template>
  <div>
    <h3 class="headline">工作台</h3>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  components: {
  },
  data () {
    return {

    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/Dashboard.vue